export const clearUser = () => {
   return {
      type: "CLEAR_USER"
   };
};
export const setUserId = (user: number) => {
   return {
      type: "SET_USER_ID",
      payload: user
   };
};
export const setUserInfo = (user: object) => {
   return {
      type: "SET_USER_INFO",
      payload: user
   };
};
export const setAvatarLink = (user: string) => {
   return {
      type: "SET_AVATAR_LINK",
      payload: user
   };
};
export const setMainPageURL = (user: string) => {
   return {
      type: "SET_MAIN_PAGE",
      payload: user
   };
};
export const setUserCurrentLocation = (user: string) => {
   return {
      type: "SET_USER_CURRENT_LOCATION",
      payload: user
   };
};

export const changeUserCartId = (shopId: string, cartId: number) => {
   return {
      type: "CHANGE_USER_CART_ID",
      payload: { shopId, cartId }
   };
};

// wtf is this for?
// export const setDepartments = (user) => {
//    return {
//       type: SET_DEPARTMENTS,
//       payload: user
//    };
// };
// // and this?
// export const setUserSessionData = (user) => {
//    return {
//       type: SET_USER_SESSION_DATA,
//       payload: user
//    };
// };
// // also never used :v
// export const addUserCart = (cart) => {
//    return {
//       type: SET_USER_CART,
//       payload: cart
//    };
// };
